<template>
  <div class="register">
    <Alert
      type="warning"
      v-for="(f, index) in $config.registerTips"
      :key="index"
    >{{ f }}</Alert>
    <validate-form
      ref="validateForm"
      :formItems="formItems"
      :formData="formData"
      labelPosition="top"
    />
    <FileUpload
      class="fileUpload"
      v-for="u in uploadList"
      :key="`${archiveQueryType}${u.type}`"
      :prompt="u.title"
      :remarks="u.remarks"
      :files.sync="u.files"
    />
  </div>
</template>

<script>
import ValidateForm from '@components/validate-form'
import { checkerTypeList, formatDate } from '@libs/util'
import FileUpload from '@components/upload'
import { formItemsFun } from './formItems'
export default {
  name: 'search-mobile-register',
  components: { ValidateForm, FileUpload },
  props: {
    formItems: {
      type: Array,
      default: () => []
    },
    formData: {
      type: Object,
      default: () => ({})
    },
    uploadList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    archiveQueryType () {
      return this.formItems.find(f => f.key === 'ArchiveQueryType')
    }
  },
  watch: {
    archiveQueryType: {
      handler () {
        const value = this.archiveQueryType ? this.archiveQueryType.value : false
        const uploadList = value ? checkerTypeList.find(f => f.value === value).uploadList : []
        this.$emit('update:uploadList', uploadList)
      },
      deep: true
    },
    formItems: {
      handler () {
        let formData = {}
        this.formItems.map(s => {
          if (s.type === 'appointmentDate') {
            formData[s.date.key] = formatDate(s.date.value)
            formData[s.select.key] = s.select.value
          } else {
            formData[s.key] = s.value
          }
        })
        this.$emit('update:formData', formData)
      },
      deep: true
    }
  },
  mounted () {
    this.buildFormItems()
  },
  methods: {
    async buildFormItems () {
      const formItems = await formItemsFun.call(this)
      this.$emit('update:formItems', formItems)
    },
    validate () {
      return this.$refs['validateForm'].validate()
    }
  }
}
</script>

<style lang="scss" scoped>
.register {
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 16px;
  overflow: auto;
}
</style>